import { createColumnHelper } from '@tanstack/react-table';

import { History } from 'types/history';
import { Status } from 'types/items';
import { convertUTCToLocal } from 'utils/dateUtils';

const col = createColumnHelper<History>();

/** Cases history relabels two statuses: OPEN shows as NEW, CLOSE as END. */
const renderStatus = (status: number) => {
  if (status === 0) {
    return 'NEW';
  }

  if (status === 12) {
    return 'END';
  }

  return Status[status];
};

const showVenue = (history: History) => history?.venue?.name || ' - ';

export const buildCasesHistoryColumns = () => [
  col.accessor(
    (history) =>
      `${(history as any)?.scannedBy?.fname || '-'} ${
        (history as any)?.scannedBy?.lname || ''
      }`,
    { id: 'scannedBy', header: 'Scan Performed By', minSize: 250 },
  ),
  col.accessor((history) => renderStatus(history?.status) || '-', {
    id: 'status',
    header: 'Status',
    minSize: 250,
  }),
  col.accessor((history) => history?.washHub?.name || '-', {
    id: 'washHub',
    header: 'Wash Hub',
    minSize: 250,
  }),
  col.accessor((history) => history?.sku?.name || '-', {
    id: 'sku',
    header: 'SKU',
    minSize: 250,
  }),
  col.accessor((history) => convertUTCToLocal(history?.createdAt, true), {
    id: 'createdAt',
    header: 'Created At',
    minSize: 250,
  }),
  col.accessor((history) => showVenue(history), {
    id: 'venue',
    header: 'Last Venue',
    minSize: 250,
    meta: { align: 'center' },
  }),
];
